<template>
    <div class="content">
          <!-- 
        - #ABOUT
      -->

      <section class="section about" id="about">
        <div class="container">
          <figure class="about-banner">
            <img
             :src="require('@/assets/img/modelo1.webp')"
              width="700"
              height="532"
              loading="lazy"
              alt="about banner"
              class="w-100 banner-animation"
            />
          </figure>

          <div class="about-content">
            <h2 class="h2 section-title underline">WHO WE ARE</h2>

            <p class="about-text">
A 360 é uma empresa especializada em consultoria estratégica e outsourcing empresarial, dedicada a apoiar organizações no desenvolvimento estrutural e no fortalecimento da performance operacional. Nascemos da necessidade crescente do mercado por soluções integradas que profissionalizem a gestão e apoiem o crescimento estruturado, especialmente no contexto das organizações angolanas. Atuamos como parceiros estratégicos, analisando globalmente as empresas através do prisma das pessoas, tecnologia, processos e desempenho.

            </p>
 <!--
            <p class="about-text">
         Ajudamos empresas a sair do comum, criar experiências relevantes e acelerar suas receitas com inteligência e proximidade.
            </p>
           
            <ul class="stats-list">
              <li class="stats-card">
                <p class="h3 stats-title">9875</p>

                <p class="stats-text">Satisfied Clients</p>
              </li>

              <li class="stats-card">
                <p class="h3 stats-title">7894</p>

                <p class="stats-text">Project Lunched</p>
              </li>

              <li class="stats-card">
                <p class="h3 stats-title">65</p>

                <p class="stats-text">Years Completed</p>
              </li>
            </ul>
          -->
          </div>
        </div>
      </section>

    </div>
</template>

<style scoped>
.content{
  background: radial-gradient(circle,rgba(246, 171, 124, 0.1) 100%, rgba(255, 255, 255, 0.11) 100%);
  text-align: justify;

}
/*-----------------------------------*\
  #ABOUT
\*-----------------------------------*/

.about-banner {
  margin-block-end: 30px;
}

.about .section-title {
  margin-inline: 0;
}

.about .underline::before {
  left: 0;
  transform: translateX(0);
}

.about-text {
  font-size: var(--fs-8);
  margin-block-end: 20px;
}

.stats-list {
  display: grid;
  gap: 30px;
}

.stats-card {
  text-align: center;
  padding: 15px;
  box-shadow: var(--shadow);
  border-radius: var(--radius-12);
}

.stats-title {
  color: var(--st-patricks-blue);
  font-size: var(--fs-2);
  font-weight: var(--fw-700);
}

.stats-text {
  font-size: var(--fs-8);
}

/*-----------------------------------*\
  #SERVICE
\*-----------------------------------*/

.service-list {
  display: grid;
  gap: 30px;
}

.service-card {
  padding: 30px;
  box-shadow: var(--shadow);
  border-radius: var(--radius-12);
}

.service-card .card-icon {
  background-image: url("https://raw.githubusercontent.com/codewithsadee/desinic/master/assets/images/service-banner-pattern.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-color: hsla(335, 87%, 53%, 0.12);
  aspect-ratio: 1 / 1;
  max-width: 165px;
  display: grid;
  place-content: center;
  margin-inline: auto;
  transition: var(--transition-1);
}

.service-card:hover .card-icon {
  background-color: var(--winter-sky);
}

.service-card .card-icon ion-icon {
  font-size: 5rem;
  color: var(--winter-sky);
  --ionicon-stroke-width: 20px;
  transition: var(--transition-1);
}

.service-card:hover .card-icon ion-icon {
  color: var(--white);
}

.service-card .title {
  text-align: center;
  margin-block-end: 15px;
}

.service-card .text {
  text-align: center;
  margin-block-end: 20px;
}

.service-card .card-btn {
  margin-inline: auto;
  padding: 15px;
  border: 1px solid var(--winter-sky);
  border-radius: 50%;
  color: var(--winter-sky);
  transition: var(--transition-1);
}

.service-card .card-btn:is(:hover, :focus) {
  color: var(--white);
  background-color: var(--winter-sky);
}

/* Celulares pequenos */
@media (max-width: 480px) {

figure{
  width:80%;
}
}
/* Celulares médios */
@media (max-width: 767px) {

figure{
  margin-top:30%;
  width:100%;

}
}
</style>